import { useI18n } from 'vue-i18n';

import {
  actionReceiptProviders,
  cadenceEnrollmentState,
  cadenceVersionLabel,
  contactReference,
  deadLetterState,
  destinationRowState,
  eventLabel,
  formatDate,
  formatDuration,
  formatPercent,
  labelColor,
  nextExecutionLabel,
  observedThresholdLabel,
  ruleRowState,
  usersLabel,
} from '../utils/automationOperationsFormatters';

/**
 * Formatters shared by the automation operations panel and its sections.
 * The pure ones come straight from ../utils/automationOperationsFormatters;
 * the ones below need the i18n catalog, so they are built per component.
 */
export const useAutomationOperationsFormatters = () => {
  const { t } = useI18n();

  const formatStatus = value => {
    if (!value) return t('AUTOMATION.OPERATIONS.UNAVAILABLE');
    return value.toString().replaceAll('_', ' ');
  };

  const deliveryStateCounts = destination =>
    Object.entries(destination.recent_delivery_counts_by_state || {})
      .map(([state, count]) => `${formatStatus(state)} ${count}`)
      .join(', ');

  const ruleSloReason = rule =>
    (rule.slo?.reasons || []).slice(0, 2).map(formatStatus).join(', ') ||
    t('AUTOMATION.OPERATIONS.RULES.NO_SLO_REASONS');

  const cadenceLastTransition = enrollment => {
    const history = enrollment.transition_history || [];
    const latest = history[history.length - 1];
    if (!latest) return '-';

    return `${formatStatus(latest.action)} · ${latest.reason}`;
  };

  const latestCadenceRunLabel = run =>
    [
      formatStatus(run.status),
      formatDate(run.started_at),
      `${run.claimed_count}/${run.enqueued_count}`,
    ].join(' · ');

  return {
    t,
    actionReceiptProviders,
    cadenceEnrollmentState,
    cadenceLastTransition,
    cadenceVersionLabel,
    contactReference,
    deadLetterState,
    deliveryStateCounts,
    destinationRowState,
    eventLabel,
    formatDate,
    formatDuration,
    formatPercent,
    formatStatus,
    labelColor,
    latestCadenceRunLabel,
    nextExecutionLabel,
    observedThresholdLabel,
    ruleRowState,
    ruleSloReason,
    usersLabel,
  };
};
